import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import InputText from "commons/ui/input/InputText";
import IntegerInput from "commons/ui/input/IntegerInput";
import Select from "commons/ui/input/Select";
import SwitchInput from "commons/ui/input/SwitchInput";
import Paper from "commons/ui/Paper";

import ExtensionsProporsionInfo from "components/subComponents/ExtensionsProporsionInfo";
import OrderableImages from "components/subComponents/OrderableImages";
import TwoLanguagesAdornment from "components/subComponents/TwoLanguagesAdornment";
import AttachmentPicker from "components/ui/AttachmentPicker";

import useShowroomForm from "hooks/form/useShowroomForm";

import { DesktopOrMobile } from "types/enums";

function ShowroomForm() {
    const { setDesktopMobileImage, orderableImagesHook, continentGroup, formHook } =
        useShowroomForm();

    const { checkErrorVisibility, setValue, form } = formHook;

    return (
        <GridColumn>
            <Paper>
                <GridColumn>
                    <GridRow>
                        <GridItem className={"title-margin"}>
                            <h2>Impostazioni</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-24-6"}>
                            <Select
                                label={"Area geografica"}
                                options={[{ value: "", label: "" }, ...continentGroup]}
                                value={form.group_id}
                                setValue={setValue}
                                path={"group_id"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-24-6"}>
                            <IntegerInput
                                label={"Ordinamento"}
                                value={form.graphical_order}
                                setValue={setValue}
                                path={"graphical_order"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-24-10"}>
                            <InputText
                                label={"Slug"}
                                value={form.slug}
                                setValue={setValue}
                                path={"slug"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-24-2 centered-toggle"}>
                            <SwitchInput
                                checked={form.enabled}
                                label={"Area pubblica"}
                                setValue={setValue}
                                path={"enabled"}
                                alignedToForm
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Immagine</h2>
                        </GridItem>
                    </GridRow>

                    <ExtensionsProporsionInfo proportion={"16:9"} />

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Desktop"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.desktop)
                                }
                                file={form.cover_img.desktop}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.desktop")}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <AttachmentPicker
                                buttonLabel={"Foto Mobile"}
                                setFile={(file) =>
                                    setDesktopMobileImage(file, DesktopOrMobile.mobile)
                                }
                                file={form.cover_img.mobile}
                                accept={".png,.jpg,.jpeg"}
                                errors={checkErrorVisibility("cover_img.mobile")}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Tour Virtuale</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-2"}>
                            <SwitchInput
                                label={"Tour virtuale"}
                                checked={form.virtual_tour}
                                setValue={setValue}
                                path={"virtual_tour"}
                            />
                        </GridItem>
                    </GridRow>

                    {form.virtual_tour && (
                        <>
                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        label={"Url del tour virtuale"}
                                        value={form.url_virtual_tour}
                                        setValue={setValue}
                                        path={"url_virtual_tour"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        label={"Primo Titolo del tour Virtuale"}
                                        value={form.text.it.virtual_tour_title_1}
                                        setValue={setValue}
                                        path={"text.it.virtual_tour_title_1"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        startAdornment={TwoLanguagesAdornment("it")}
                                        label={"Secondo Titolo del tour Virtuale"}
                                        value={form.text.it.virtual_tour_title_2}
                                        setValue={setValue}
                                        path={"text.it.virtual_tour_title_2"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>

                            <GridRow>
                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        label={"Primo Titolo del tour Virtuale"}
                                        value={form.text.en.virtual_tour_title_1}
                                        setValue={setValue}
                                        path={"text.en.virtual_tour_title_1"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>

                                <GridItem className={"col-xs-12-6"}>
                                    <InputText
                                        startAdornment={TwoLanguagesAdornment("en")}
                                        label={"Secondo Titolo del tour Virtuale"}
                                        value={form.text.en.virtual_tour_title_2}
                                        setValue={setValue}
                                        path={"text.en.virtual_tour_title_2"}
                                        checkErrorVisibility={checkErrorVisibility}
                                    />
                                </GridItem>
                            </GridRow>
                        </>
                    )}

                    <GridRow className="title-margin">
                        <GridItem>
                            <h2>Testo Italiano</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("it")}
                                label={"Titolo"}
                                value={form.text.it.title}
                                setValue={setValue}
                                path={"text.it.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("it")}
                                label={"Primo indirizzo"}
                                value={form.text.it.address_1}
                                setValue={setValue}
                                path={"text.it.address_1"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("it")}
                                label={"Secondo indirizzo"}
                                value={form.text.it.address_2}
                                setValue={setValue}
                                path={"text.it.address_2"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow className={"title-margin"}>
                        <GridItem>
                            <h2>Testo Inglese</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-12"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("en")}
                                label={"Titolo"}
                                value={form.text.en.title}
                                setValue={setValue}
                                path={"text.en.title"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("en")}
                                label={"Primo indirizzo"}
                                value={form.text.en.address_1}
                                setValue={setValue}
                                path={"text.en.address_1"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>

                        <GridItem className={"col-xs-12-6"}>
                            <InputText
                                startAdornment={TwoLanguagesAdornment("en")}
                                label={"Secondo indirizzo"}
                                value={form.text.en.address_2}
                                setValue={setValue}
                                path={"text.en.address_2"}
                                checkErrorVisibility={checkErrorVisibility}
                            />
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"title-margin"}>
                            <h2>Immagini</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow>
                        <GridItem className={"col-xs-24-3"}>
                            <SwitchInput
                                label={"Galleria"}
                                checked={form.gallery}
                                setValue={setValue}
                                path={"gallery"}
                            />
                        </GridItem>
                    </GridRow>

                    {form.gallery && <ExtensionsProporsionInfo proportion={"16:9"} />}
                </GridColumn>

                {form.gallery && <OrderableImages orderableImagesHook={orderableImagesHook} />}
            </Paper>
        </GridColumn>
    );
}

export default ShowroomForm;
